import { FieldValues, FormState } from 'react-hook-form';

interface Props {
  formState: FormState<FieldValues>;
}

const FormServerError = ({ formState }: Props): JSX.Element | null => {
  const { errors } = formState;

  if (errors?.['serverError'])
    return (
      <span className="text-red500">
        {errors['serverError'].message?.toString()}
      </span>
    );

  return null;
};
export default FormServerError;
